// Input clear payment options on navigation
// Used to clear E-lasku/Kortti payment options when user navigates
// between previous steps to ensure the user makes the correct
// decision about their payment methods.
// ----------------------------------------------------------------

import $ from 'jquery';

export function inputClearPaymentOptionsOnNavigation() {
    // Sets payment checkboxes to unchecked and
    // hides active styling
    $('input[name="donation-payment-method"]').prop('checked', false);
    $('input[name="donation-payment-method"]').closest('label').removeClass('u-bg-yellow');

    // Hides payment methods
    $('.js-selectPaymentMethodTarget').hide();

    // Sets possible bank selection checkboxes to unchecked and
    // hides active styling
    $('input[name="donation-payment-bank"]').prop('checked', false);
    $('input[name="donation-payment-bank"]').closest('label').removeClass('u-bg-yellow');

    // Hides due date selections
    $('.js-selectDueDateTarget').hide();

    // Sets possible due date selection checkboxes to unchecked and
    // hides active styling
    $('input[name="due-date"]').prop('checked', false);
    $('input[name="due-date"]').closest('label').removeClass('u-bg-yellow');
}
